/** Shared [CLIP:…] segment helpers — timeline ↔ Videos tab tag pairing. */

export const CLIP_TEXT_PREFIX = '[CLIP:';
export const CLIP_TEXT_SUFFIX = ']';

export function isClipSegmentText(text) {
  return (
    typeof text === 'string'
    && text.startsWith(CLIP_TEXT_PREFIX)
    && text.endsWith(CLIP_TEXT_SUFFIX)
  );
}

/** Build segment box text from a Videos-tab clip tag (e.g. clip1 → [CLIP:clip1]). */
export function clipTextFromTag(tag) {
  const t = (tag || '').trim();
  if (!t) return '';
  return `${CLIP_TEXT_PREFIX}${t}${CLIP_TEXT_SUFFIX}`;
}

export function extractClipTagFromText(text) {
  if (!isClipSegmentText(text)) return '';
  return text.slice(CLIP_TEXT_PREFIX.length, -CLIP_TEXT_SUFFIX.length).trim();
}

/** All tagged vidclips in a section (intro / body / conclusion). */
export function getTaggedClipsInSection(selectedData, sectionKey) {
  const out = [];
  const clips = selectedData?.[sectionKey]?.clips || [];
  clips.forEach(charClip => {
    (charClip.videos || []).forEach(video => {
      (video.vidclips || []).forEach((clip, clipIndex) => {
        const tag = (clip.tag || '').trim();
        if (!tag) return;
        out.push({
          tag,
          character: charClip.characterName,
          url: video.url,
          clipIndex,
        });
      });
    });
  });
  return out;
}

/** Tags already represented on timeline segments (tag field or [CLIP:…] text). */
export function getUsedClipTagsInSegments(segments) {
  const used = new Set();
  (segments || []).forEach(seg => {
    const fromText = extractClipTagFromText(seg?.text);
    const fromTag = (seg?.tag || '').trim();
    if (fromText) used.add(fromText);
    if (fromTag) used.add(fromTag);
  });
  return used;
}

/**
 * Suggest clip segments for tags enabled on Videos tab but not yet on timeline.
 * Each suggestion inserts `{ text: [CLIP:tag], tag }` matching manual workflow.
 */
export function getClipSegmentSuggestions(selectedData, sectionKey, segments) {
  const tagged = getTaggedClipsInSection(selectedData, sectionKey);
  const used = getUsedClipTagsInSegments(segments);
  const seen = new Set();
  const suggestions = [];

  tagged.forEach(item => {
    if (used.has(item.tag) || seen.has(item.tag)) return;
    seen.add(item.tag);
    suggestions.push({
      ...item,
      label: item.tag,
      clipText: clipTextFromTag(item.tag),
    });
  });

  return suggestions;
}
